<template>
  <div>
    <nav aria-label='breadcrumb'>
      <ol class='breadcrumb'>
        <li class='breadcrumb-item'>
          <a href='#'>{{ translations('navbar.return_management') }}</a>
        </li>
        <li class='breadcrumb-item'>
          <router-link to='/archive-replacement'>{{ translations('replacement.archive_replacement') }}</router-link>
        </li>
        <li class='breadcrumb-item active' aria-current='page'>{{ translations('replacement.replacement_detail') }}</li>
      </ol>
    </nav>
    <div class='container-fluid main-container'>
      <div class='d-flex flex-wrap'>
        <div class='left-container'>
<!--           <div class='form mb-4'>
            <div class='form-group'>
              <button class='btn btn-primary' :disabled="!isNotYet()" data-toggle="modal" data-target="#SingleReplacementModal">出荷処理</button>
            </div>
          </div> -->
          <h5 class='mb-3'>Information</h5>
          <table class='table table-sm table-borderless table-information'>
            <tbody>
              <tr>
                <th>{{ translations('replacement.processing_date') }}</th>
                <td>
                  <button
                    ref='info06'
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-info06'
                    data-placement='right'
                  >{{ replacementInfo.processed_at ? $invoiceTools.formatDate(replacementInfo.processed_at) : '----------'}}</button>
                  <div id='popover-info06' class='popover popover-x popover-default'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{ translations('replacement.processing_date') }}
                    </div>
                    <div class='popover-body popover-content'>
                      <input type='date' v-model='tempInfo.processed_at' class='form-control'>
                    </div>
                    <div class='popover-footer'>
                      <button
                        @click="updateField('processed_at',tempInfo.processed_at,'info06')"
                        type='submit'
                        class='btn btn-sm btn-primary'
                      >OK</button>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>{{ translations('replacement.organization_number') }}</th>
                <td>{{replacementInfo.reference_number}}</td>
              </tr>
              <tr>
                <th>{{ translations('replacement.remarks') }}</th>
                <td>
                  <button ref="info10" type='button' class='btn btn-link p-0' data-toggle='popover-x' data-target='#popover-info10' data-placement='right'>{{ replacementInfo.memo ? replacementInfo.memo : '--------------' }}</button>
                  <div id='popover-info10' class='popover popover-x popover-default'>
                      <div class='arrow'></div>
                      <div class='popover-header popover-title'><button class='close' data-dismiss='popover-x'>&times;</button>{{ translations('replacement.remarks') }}</div>
                      <div class='popover-body popover-content'>
                        <textarea class="form-control" v-model="tempInfo.memo"></textarea>
                      </div>
                      <div class='popover-footer'>
                        <button type='submit' v-on:click="updateField('memo', tempInfo.memo, 'info10')" class='btn btn-sm btn-primary'>
                          {{ translations('common.update') }}</button>
                      </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>{{ translations('common.last_updated_by') }}</th>
                <td>{{tempInfo.updated_by}}</td>
              </tr>
              <tr>
                <th>{{ translations('common.last_update_time') }}</th>
                <td>{{tempInfo.updated_at}}</td>
              </tr>
              <tr>
                <th class="is_processed">{{ translations('replacement.processing_status') }}</th>
                <td>
                  <button type="button" class="btn btn-primary btn-sm" v-if="Number(replacementInfo.is_processed) === 0" v-on:click="clickIsProcessed()">
                    {{ translations('replacement.mark_processed') }}</button>
                  <button type="button" class="btn btn-primary btn-sm" v-else v-on:click="clickIsProcessed()">{{ translations('replacement.revert_unprocessed') }}</button>
                </td>
              </tr>
            </tbody>
          </table>
          <hr>
          <div class='form-inline'>
            <div class='form-group'>
              <a class='btn btn-link btn-sm text-danger' @click.self="deleteReplacement()" href='javascript:;'>{{ translations('common.delete') }}</a>
            </div>
          </div>
          <hr>
          <div>
            <h5 class='mb-3'>Check list</h5>
            <div class='padding-inline-start-5px'>
              <div>◎{{ translations('replacement.best_condition') }}
                <ul class='margin-bottom-10px'>
                  <li>{{ translations('replacement.sealed_item') }}</li>
                </ul>
              </div>
              <div>○{{ translations('replacement.good_condition') }}
                <ul class='margin-bottom-10px'>
                  <li>{{ translations('replacement.unopened_unused') }}</li>
                </ul>
              </div>
              <div>△{{ translations('replacement.usable') }}
                <ul class='margin-bottom-10px'>
                  <li>{{ translations('replacement.functional_item') }}</li>
                </ul>
              </div>
              <div>×{{ translations('replacement.not_usable') }}
                <ul class='margin-bottom-10px'>
                  <li>{{ translations('replacement.immovable_damaged') }}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class='right-container'>
<!--          <div v-if="hasSetItem && replacementInfo.client_id !== -2" class="alert alert-primary d-flex align-items-center">-->
<!--            <button class="btn btn-sm btn-primary mr-3" type="button" data-toggle="modal" data-target="#SingleReturnsModal">-->
<!--              {{ translations('replacement.break_up_the_set') }}</button>-->
<!--            <ul id="set-item-list">-->
<!--              <li v-for="(item, i) in setItems" :key="i"><span class="font-weight-bold">{{ item.model }}</span></li>-->
<!--            </ul>-->
<!--          </div>-->
          <div class="form-inline justify-content-end"><!-- VAT -->
            <div v-if="taxIncluded" class="text-danger">{{ translations('common.tax_included') }}</div><!-- TAXSTATUS -->
            <div v-else>{{ translations('common.tax_excluded') }}</div>
          </div>
          <div class='table-scroll mb-4'>
            <table class='table table-sm table-striped table-1500 table-align-middle'>
              <thead>
                <tr>
                  <th></th>
                  <th>{{ translations('replacement.replacement_status') }}</th>
                  <th>{{ translations('replacement.receiving_warehouse') }}</th>
                  <th>{{ translations('replacement.shipping_warehouse') }}</th>
                  <th>{{ translations('replacement.reason_return') }}</th>
                  <th>{{ translations('replacement.operation_confirmation') }}</th>
                  <th>{{ translations('replacement.verification_results') }}</th>
                  <th>{{ translations('replacement.model_number') }}</th>
                  <th>{{ translations('replacement.number_item') }}</th>
                  <th class="width-50-px">{{ translations('replacement.unit_price') }}</th>
                  <th class="width-50-px"></th>
                  <th>{{ translations('replacement.original_unit_price') }}</th>
                  <th>{{ translations('replacement.summary') }}</th>
                  <th>{{ translations('replacement.unit_price_total') }}</th>
                  <th>{{ translations('replacement.total_liabilities') }}</th>
                </tr>
              </thead>
              <tbody class="nowrap">
                <template v-for='(detail, i) in replacementDetails'>
                  <tr v-if="Number(detail.set_status) !== 2" :key='i'>
                    <td>
                      <button v-if="!Number(replacementInfo.is_processed)" @click="deleteDetail(i)" class='btn-change minus'><i></i></button>
                    </td>

<!--                    <td v-if="!Number(replacementInfo.is_processed) && Number(detail.set_status) !== 1">-->
                    <td>
                      <button type='button' class='btn btn-link p-0' data-toggle='popover-x' :data-target="'#popover-status' + i" data-placement='right'>
                        {{ (detail.replacement_status_id) ? getRetrunPropsById(replacement_statuses, detail.replacement_status_id, 'name') : '-------------' }}
                      </button>
                      <div :ref="'status' + i" :id="'popover-status' + i" class='popover popover-x popover-default'>
                        <div class='arrow'></div>
                        <div class='popover-header popover-title'><button class='close' data-dismiss='popover-x'>&times;</button>
                          {{ translations('replacement.replacement_status') }}</div>
                        <div class='popover-body popover-content'>
                          <select v-model="tempDetails[i].replacement_status_id" class="custom-select">
                            <template  v-for="(status, i) in replacement_statuses">
                              <option :key="i" :value="status.id">{{ status.name }}</option>
                            </template>
                          </select>
                        </div>
                        <div class='popover-footer'>
                          <button @click="onChangeStatus(detail, i)" type='submit' class='btn btn-sm btn-primary'>OK</button>
                        </div>
                      </div>
                    </td>
<!--                    <td v-else>{{ getRetrunPropsById(replacement_statuses, detail.replacement_status_id, 'name') }}</td>-->

                    <td v-if="detail.id">
                      <button type='button' class='btn btn-link p-0' data-toggle='popover-x' :data-target="'#popover-arrived_warehouse' + i" data-placement='right'>
                        {{ detail.arrived_warehouse ? warehouseName(detail.arrived_warehouse.id) : '-------------' }}
                        {{ detail.arrived_warehouse ? stockType(detail.arrived_stock_type ? detail.arrived_stock_type.id: '') : '' }}
                      </button>
                      <div :ref="'arrived_warehouse' + i" :id="'popover-arrived_warehouse' + i" class='popover popover-x popover-default popover-fit-content'>
                        <div class='arrow'></div>
                        <div class='popover-header popover-title'><button class='close' data-dismiss='popover-x'>&times;</button>
                          {{ translations('replacement.receiving_warehouse') }}</div>
                        <div class='popover-body popover-content'>
                          <input type='date' v-model='tempDetails[i].arrived_at' class='form-control' @input="onInputArrivedWarehouseItems(tempDetails[i])">
                          <v-select :options="warehouses" label="name" value="id" v-model="tempDetails[i].arrived_warehouse" @input="onInputArrivedWarehouseItems(tempDetails[i])"></v-select>
                          <v-select :options="stockTypes" label="name" value="id" v-model="tempDetails[i].arrived_stock_type" @input="onInputArrivedWarehouseItems(tempDetails[i])"></v-select>
                        </div>
                        <div class='popover-footer'>
                          <button @click="onChangeArrivedWarehouse(detail, i)" type='submit' class='btn btn-sm btn-primary' :disabled="disabledWarehouse.arrivedBtn">OK</button>
                        </div>
                      </div>
                    </td>
                    <td v-else>-------------</td>

                    <td v-if="detail.id">
                      <button type='button' class='btn btn-link p-0' data-toggle='popover-x' :data-target="'#popover-shipped_warehouse' + i" data-placement='right'>
                        {{ detail.shipped_warehouse ? warehouseName(detail.shipped_warehouse.id) : '-------------' }}
                        {{ detail.shipped_warehouse ? stockType(detail.shipped_stock_type ? detail.shipped_stock_type.id: '') : '' }}
                      </button>
                      <div :ref="'shipped_warehouse' + i" :id="'popover-shipped_warehouse' + i" class='popover popover-x popover-default popover-fit-content'>
                        <div class='arrow'></div>
                        <div class='popover-header popover-title'><button class='close' data-dismiss='popover-x'>&times;</button>
                          {{ translations('replacement.shipping_warehouse') }}</div>
                        <div class='popover-body popover-content'>
                          <input type='date' v-model='tempDetails[i].shipped_at' class='form-control' @input="onInputShippedWarehouseItems(tempDetails[i])">
                          <v-select :options="warehouses" label="name" value="id" v-model="tempDetails[i].shipped_warehouse" @input="onInputShippedWarehouseItems(tempDetails[i])"></v-select>
                          <v-select :options="stockTypes" label="name" value="id" v-model="tempDetails[i].shipped_stock_type" @input="onInputShippedWarehouseItems(tempDetails[i])"></v-select>
                        </div>
                        <div class='popover-footer'>
<!--                          <button @click="onChangeShippedWarehouse(detail, i)" type='submit' class='btn btn-sm btn-primary' :disabled="disabledWarehouse.shippedBtn">OK</button>-->
                          <button type='submit' class='btn btn-sm btn-primary' :disabled="disabledWarehouse.shippedBtn" @click="onChangeShippedWarehouse(detail, i)">OK</button>
                        </div>
                      </div>
                    </td>
                    <td v-else>-------------</td>

                    <td>
                      <button type='button' class='btn btn-link p-0' data-toggle='popover-x' :data-target="'#popover-reason' + i" data-placement='right'>
                        {{ (detail.replacement_reason_id) ? getRetrunPropsById(replacement_reasons, detail.replacement_reason_id, 'name') : '-------------' }}
                      </button>
                      <div :ref="'reason' + i" :id="'popover-reason' + i" class='popover popover-x popover-default'>
                        <div class='arrow'></div>
                        <div class='popover-header popover-title'><button class='close' data-dismiss='popover-x'>&times;</button>
                          {{ translations('replacement.reason_return') }}</div>
                        <div class='popover-body popover-content'>
                          <select v-model="tempDetails[i].replacement_reason_id" class="custom-select">
                            <template v-for="(reason, i) in replacement_reasons">
                              <!-- 破棄済以外 -->
                              <option :key="i" :value="reason.id">{{ reason.name }}</option>
                            </template>
                          </select>
                        </div>
                        <div class='popover-footer'>
                          <button @click="onChangeReason(detail, i)" type='submit' class='btn btn-sm btn-primary'>OK</button>
                        </div>
                      </div>
                    </td>

                    <td>
                      <button
                        type='button'
                        class='btn btn-link p-0'
                        data-toggle='popover-x'
                        :data-target="'#popover-info0000' + i"
                        data-placement='right'
                      >{{ (detail.replacement_state_id) ? getRetrunPropsById(replacement_states, detail.replacement_state_id, 'name') : '-------------' }}</button>
                      <div :ref="'info0000' + i" :id="'popover-info0000' + i" class='popover popover-default popover-x has-footer'>
                        <div class='arrow'></div>
                        <div class='popover-header popover-title'>
                          <button class='close' data-dismiss='popover-x'>×</button>
                          {{ translations('replacement.operation_confirmation') }}
                        </div>
                        <div class='popover-body popover-content'>
                          <select v-model="tempDetails[i].replacement_state_id" class="custom-select">
                            <template  v-for="(state, i) in replacement_states">
                              <option :key="i" :value="state.id">{{ state.name }}</option>
                            </template>
                          </select>
                        </div>
                        <div class='popover-footer'>
                          <button @click="onChangeState(detail, i)" type='submit' class='btn btn-sm btn-primary'>OK</button>
                        </div>
                      </div>
                      <div class='popover-x-marker' style='display: none;'></div>
                    </td>
                    <td>
                      <button
                        type='button'
                        class='btn btn-link p-0'
                        data-toggle='popover-x'
                        :data-target="'#popover-test_result' + i"
                        data-placement='right'
                      >{{ detail.test_result ? detail.test_result : '-------------' }}</button>
                      <div :ref="'popover-test_result' + i" :id="'popover-test_result' + i" class='popover popover-default popover-x has-footer'>
                        <div class='arrow'></div>
                        <div class='popover-header popover-title'>
                          <button class='close' data-dismiss='popover-x'>×</button>
                          {{ translations('replacement.verification_results') }}
                        </div>
                        <div class='popover-body popover-content'>
                          <textarea class='form-control' v-model="tempDetails[i].test_result"></textarea>
                        </div>
                        <div class='popover-footer'>
                          <button @click="onChangeTestResult(detail, i)" type='submit' class='btn btn-sm btn-primary'>OK</button>
                        </div>
                      </div>
                      <div class='popover-x-marker' style='display: none;'></div>
                    </td>

                    <td>{{ (typeof detail.model === 'number') ? getRetrunPropsById(products, detail.model, 'model') : detail.model }}</td>

                    <td class="right">{{ detail.quantity.toLocaleString() }}</td>

                    <td v-if="!replacementInfo.is_processed">
                      <div class="number-container"><!-- input 含む number-container ブロック -->
                        <input type="text" @input="numbers(i,'unit_price')" class="form-control form-control-sm number-input" style="width:6em;" v-model="detail.unit_price" @focus="refresh('unit_price')" @blur="refresh('unit_price')" @change="onChangeUnitPrice(detail)"/><!-- 既存の class に number-input 追記、id focus blur 記入 -->
                        <span class="form-control form-control-sm number-overlap" style="width:6em;">{{ detail.unit_price && detail.unit_price.toLocaleString() }}</span><!-- input 同様の class に number-overlap 追記、style も転記 -->
                      </div>
                    </td>
                    <td v-else>{{ toTaxFormat(detail, 'unit_price') }}</td>

                    <td v-if="Number(detail.taxclass_id) === 1" class="right">({{ $util.getIncludeTax(detail.unit_price, detail.tax_rate).toLocaleString()}})</td>
                    <td v-else></td>

                    <td class="right">
                      <div class="number-container"><!-- input 含む number-container ブロック -->
                        <input type="text" @input="numbers(i,'row_price')" class="form-control form-control-sm number-input" style="width:6em;" v-model="detail.row_price" @focus="refresh('row_price')" @blur="refresh('row_price')" /><!-- 既存の class に number-input 追記 -->
                        <span class="form-control form-control-sm number-overlap" style="width:6em;">{{ detail.row_price && detail.row_price.toLocaleString() }}</span><!-- input 同様の class に number-overlap 追記、style も転記 -->
                      </div>
                    </td>

                    <td class="right"><input type="text" class="form-control form-control-sm" style="width:10em;" v-model="detail.remarks" @change="onChangeRemarks(detail)"/></td>
                    <td class="right">{{ toTaxFormat(detail, 'total_unit_price') }}</td>
                    <td class="right">{{ toTaxFormat(detail, 'total_cost') }}</td>
                  </tr>
                </template>
                <tr class='bg-lightgreen'>
                  <td>
                    <button @click="openAddDetailModal()" class='btn-change plus' type='button'><i></i></button>
                    <button ref="openAddDetailModal" hidden="true" class='btn-change plus' type='button' data-toggle='modal' data-target='#NewReplacementModal'><i></i></button>
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td class='font-weight-bold right'>{{ displayGrandTotal(grandTotalUnitPrice, grandTotalUnitPriceIncTax) }}</td>
                  <td class='font-weight-bold right'>{{ displayGrandTotal(grandTotalDebt, grandTotalDebtIncTax) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class='form-inline'>
            <div class='form-group mr-2'>
              <!-- 追加か削除された場合にのみ有効化 -->
              <button :disabled="!isAddOrDelete" @click="updateReplacement()" class='btn btn-sm btn-primary'>{{ translations('common.update') }}</button>
            </div>
            <div class="form-group">
              <a v-if="isAllDone()" class="btn btn-link btn-sm decoration-underline" href="javascript:;" @click="openDeliverySlip()">{{ translations('replacement.print_exchange_slip') }}<i class="fas fa-external-link-alt"></i></a>
              <a v-else class="btn btn-link btn-sm decoration-underline disabled" href="#" >{{ translations('replacement.print_exchange_slip') }}<i class="fas fa-external-link-alt"></i></a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <NewReplacementModal
      :replacementDetails='replacementDetails'
      :replacementStatuses="replacement_statuses"
      :replacementReasons="replacement_reasons"
      :replacementStates="replacement_states"
      :products="products"
      :vat="{taxIncluded:taxIncluded, vatRate:vatRate}"
    /><!-- VAT -->
    <SingleReturnsModal :setItems="setItems" :return_id="replacementId" :returnDetails='replacementDetails'/>
    <SingleReturnMoveModal :warehouses="warehouses" :warehouseId="tempInfo.warehouses_id" :replacementDetail="selectedDetail" />
    <SingleReplacementShippedWarehouseModal :replacementDetail="selectedDetail" :index="selectedIdx" :returnDetail="returnDetail"/>
    <!-- <SingleReplacementModal :replacementId="replacementId" /> -->
    <vue-element-loading :active="isLoading" :is-full-screen="true"/>
  </div>
</template>

<script>
import $ from 'jquery' // number-container
import VueElementLoading from 'vue-element-loading'
import NewReplacementModal from '@/components/NewReplacementModal'
import SingleReturnsModal from '@/components/SingleReturnModal'
import SingleReturnMoveModal from '@/components/SingleReturnMoveModal'
import SingleReplacementShippedWarehouseModal from '@/components/SingleReplacementShippedWarehouseModal'
import { QuantityProduct, ReplacementStatus } from '@/constants'
import {mapState} from "vuex";

export default {
  name: 'SingleReplacement',
  props: {},
  components: {
    VueElementLoading,
    NewReplacementModal,
    SingleReturnsModal,
    SingleReturnMoveModal,
    SingleReplacementShippedWarehouseModal
  },
  watch: {
    replacementDetails: {
      handler (v) {
        v.forEach((d, i) => {
          if (typeof d !== 'undefined') {
            v[i] = this.prepareDetails(d)
          }
        })
        this.tempDetails = JSON.parse(JSON.stringify(v))
        this.calcGrandTotals()
        this.withSetItem()
        this.refresh('row_price') // 原価
        setTimeout(() => {
          this.popoverButtons()
        }, 1000)
      },
      deep: true
    }
  },
  data () {
    return {
      latestStatusId: {},
      vatRate: 0, // VAT
      taxIncluded: false, // VAT
      billingId: 0,
      replacementId: 0,
      isLoading: false,
      replacementInfo: {},
      replacementDetails: [],
      tempInfo: {},
      tempDetails: [],
      products: [],
      grandTotalUnitPrice: 0,
      grandTotalUnitPriceIncTax: 0,
      grandTotalDebt: 0,
      grandTotalDebtIncTax: 0,
      setItems: [],
      selectedDetail: null,
      deliveryFile: null,
      disabledWarehouse: {
        arrivedBtn: false,
        shippedBtn: false
      },
      returnDetail: {},
      selectedIdx: null,
      reference_number: null,
      replacementStatusId: null
    }
  },
  computed: {
    ...mapState(['currentLanguage']),
    warehouses () {
      return this.$store.getters['Master/getMywarehouses']
    },
    processType: function () {
      const self = this
      return function (detail) {
        let action = ''
        switch (detail.replacement_status_id) {
          case self.$const['RETURN_PROCESS_新品']:
          case self.$const['RETURN_PROCESS_相殺済み']:
          case self.$const['RETURN_PROCESS_代替済み']:
            action = 'move'
            break
          case self.$const['RETURN_PROCESS_破棄待ち']:
            action = 'discard'
            break
        }
        return action
      }
    },
    warehouseName: function () {
      const self = this
      return function (warehouseId) {
        const target = self.warehouses.find((item) => item.id === Number(warehouseId))
        return target ? target.name : '-------------'
      }
    },
    replacement_reasons () {
      return this.$store.getters['Return/getReasons']
    },
    replacement_statuses () {
      const statuses = this.$store.getters['Replacement/getStatuses']
      return this.translateStatuses(statuses)
    },
    replacement_states () {
      const states = this.$store.getters['Return/getStates']
      return this.translateStates(states)
    },
    isAddOrDelete () {
      return JSON.stringify(this.replacementInfo) !== JSON.stringify(this.originalInfo) || JSON.stringify(this.replacementDetails.map(detail => detail.id)) !== JSON.stringify(this.originalDetails.map(detail => detail.id))
    },
    hasSetItem () {
      return this.replacementDetails.filter(detail => detail.set_status === 1).length > 0
    },
    stockTypes () {
      return [
        { id: 1, name: '新品' },
        { id: 2, name: '不良品' },
        { id: 3, name: 'アウトレット品' }
      ]
    },
    stockType () {
      return function (key) {
        const item = {
          1: '[新品]',
          2: '[不良品]',
          3: '[アウトレット品]'
        }
        return item[key]
      }
    }
  },
  created () {
    if (!this.$route.query.replacement_id) {
      this.$router.replace('archive-replacement')
      return
    }

    this.replacementId = Number(this.$route.query.replacement_id)

    this.$store.dispatch('Return/checkReasons')
    this.$store.dispatch('Replacement/checkStatuses')
    this.$store.dispatch('Return/checkStates')
    this.$store.dispatch('Master/checkMywarehouses')

    this.getReplacementDetails().catch(error => {
      this.$toastr.error(error.message, 'エラー')
    }).finally(() => {
      this.popoverButtons()
    })
  },
  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    translateStatuses (statuses) {
      return statuses.map(status => ({
        ...status,
        name: this.translations(`statuses.${status.name}`)
      }))
    },
    translateStates (states) {
      return states.map(state => ({
        ...state,
        name: this.translations(`states.${state.name}`)
      }))
    },
    getReplacementDetails () {
      this.isLoading = true
      return this.$http.post(this.$api_url.replacement_details, { replacement_id: this.replacementId }).then(response => {
        const result = response.data
        if (result.status === true) {
          this.replacementInfo = result.information
          this.replacementDetails = result.details
          this.taxIncluded = result.information.tax_included
          this.vatRate = result.information.tax_rate
          this.replacementStatusId = result.details

          this.tempInfo = JSON.parse(JSON.stringify(this.replacementInfo))
          this.tempDetails = JSON.parse(JSON.stringify(this.replacementDetails))

          this.originalInfo = JSON.parse(JSON.stringify(this.replacementInfo))
          this.originalDetails = JSON.parse(JSON.stringify(this.replacementDetails))
        } else {
          return Promise.reject(new Error(result.message))
        }
      }).catch(function (error) {
        console.log('SingleReplacement:getReplacementDetails:catch(error): ', error)
        return Promise.reject(new Error('エラーのため失敗しました。ご確認後、再試行してください。'))
      }).finally(() => {
        this.isLoading = false
      })
    },
    toTaxFormat (data, key) {
      const price = data[key] || 0

      if (data.taxclass_id && Number(data.taxclass_id) === 2) { // 税区分（1:課税対象, 2:対象外）
        if (key === 'unit_price') {
          data.unit_price = price
          data.unit_price_inctax = price
        }
        return Number(price).toLocaleString()
      }

      const taxIncluded = data.tax_included || this.taxIncluded
      const taxRate = Number(data.tax_rate || this.taxRate)
      const inctax = this.$util.getIncludeTax(price, taxRate)
      if (key === 'unit_price') {
        data.unit_price = price
        data.unit_price_inctax = inctax
      }
      if (!taxIncluded) { // 税込以外
        return `${Number(price).toLocaleString()} (${Number(inctax).toLocaleString()})`
      } else {
        return `${Number(inctax).toLocaleString()} (${Number(price).toLocaleString()})`
      }
    },

    prepareDetails (data) {
      data.total_cost = data.quantity * data.row_price
      data.total_unit_price = data.quantity * data.unit_price

      if (data.taxclass_id && Number(data.taxclass_id) === 2) { // 税区分（1:課税対象, 2:対象外）
        data.total_cost_inctax = data.total_cost
        data.total_unit_price_inctax = data.total_unit_price
      } else {
        data.total_cost_inctax = this.$util.getIncludeTax(data.total_cost, data.tax_rate)
        data.total_unit_price_inctax = this.$util.getIncludeTax(data.total_unit_price, data.tax_rate)
      }

      data.arrived_warehouse = this.warehouses.find(item => item.id === Number(data.arrived_warehouse_id))
      data.shipped_warehouse = this.warehouses.find(item => item.id === Number(data.shipped_warehouse_id))
      data.arrived_stock_type = this.stockTypes.find(item => item.id === Number(data.arrived_stock_type_id))
      data.shipped_stock_type = this.stockTypes.find(item => item.id === Number(data.shipped_stock_type_id))
      return data
    },

    calcGrandTotals () {
      this.grandTotalUnitPrice = 0
      this.grandTotalDebt = 0

      this.replacementDetails.forEach(v => {
        this.grandTotalUnitPrice += Number(v.total_unit_price)
        if (v.return_status_id === 1) {
          this.grandTotalDebt += Number(v.total_cost)
        }
      })

      this.grandTotalUnitPriceIncTax = this.$util.getIncludeTax(this.grandTotalUnitPrice, this.taxRate)
      this.grandTotalDebtIncTax = this.$util.getIncludeTax(this.grandTotalDebt, this.taxRate)
    },

    displayGrandTotal (val, valIncTax) {
      if (!this.taxIncluded) { // 税抜
        return `${Number(val).toLocaleString()} (${Number(valIncTax).toLocaleString()})`
      } else {
        return `${Number(valIncTax).toLocaleString()} (${Number(val).toLocaleString()})`
      }
    },

    refresh (id) { // number-container
      var element = document.querySelectorAll("[id='" + id + "']")
      for (var i = 0; i < element.length; i++) {
        let $this = $(element[i])
        $this.val(Number($this.val())) // TO NUMBER
        $this.next().text((+$this.val()).toLocaleString()) // REFRESH
      }
    },
    numbers (index, target) {
      this.replacementDetails[index][target] = this.replacementDetails[index][target].toString().replace(/[^0-9.-]/g, '')
    },

    openAddDetailModal () {
      this.getProducts()
    },
    setEmptyData () {
      this.replacementInfo = {}
      this.replacementDetails = []
      this.tempInfo = {}
      this.tempDetails = []
      this.products = []
    },

    async getBoundProduct () {
      try {
        let boundProduct = await this.$http.post(this.$api_url.replacement_bound_product, { replacement_id: this.replacementId })
        let $data = this.$invoiceTools.prepareResult(boundProduct.data, 'list', 'SingleReplacement:getBoundProduct')
        if ($data.success === true) {
          let temp = []
          $data.data.forEach(d => {
            if (!this.$invoiceTools.isInArrayObj(temp, 'set_id', d.set_id)) {
              temp.push(d)
            }
          })
          this.setItems = temp
        } else {
          this.$toastr.error($data.data, 'エラー')
        }
      } catch (error) {
        console.log('SingleReplacement:getBoundProduct:catch(error): ', error)
        this.$toastr.error('エラーのため失敗しました。ご確認後、再試行してください。', 'エラー')
      }
    },

    async openDeliverySlip () {
      if (!this.deliveryFile) {
        try {
          const response = await this.$http.post(this.$api_url.replacement_delivery_slip, { replacement_id: this.replacementId })
          const result = response.data
          if (result.status === true && result.slip) {
            this.deliveryFile = result.slip
          } else {
            this.$toastr.error(result.message, 'エラー')
          }
        } catch (error) {
          console.log('SingleReturn:openDeliverySlip:catch(error): ', error)
          this.$toastr.error('エラーのため失敗しました。ご確認後、再試行してください。', 'エラー')
        }
      }

      if (this.deliveryFile) {
        let arrBuff = this.__b64ToArrayBuffer(this.deliveryFile.replace('data:application/pdf;base64,', ''))
        const deliveryFile = new Blob([arrBuff], { type: 'application/pdf' })
        const deliveryFileURL = URL.createObjectURL(deliveryFile)
        window.open(deliveryFileURL)
      }
    },

    __b64ToArrayBuffer (base64) {
      let binaryString = window.atob(base64)
      let len = binaryString.length
      let bytes = new Uint8Array(len)
      for (let i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i)
      }
      return bytes.buffer
    },

    popoverButtons () {
      window.$("button[data-toggle='popover-x']").each(function () {
        let targetID = window.$(this).attr('data-target')
        window.$(this).popoverButton({
          target: targetID,
          trigger: 'click'
        })
      })
    },

    /**
     * @param field : sales information props
     * @param value : value
     * @param ref   : reference trigger
     */
    updateField (field, value, ref, propToUpdate, originIndex) {
      let val = ''
      const rg = /^\s+$/
      if (
        !value ||
        value === '-' ||
        value === '' ||
        rg.test(value) === true ||
        typeof value === 'undefined'
      ) {
        this.$refs[ref].innerText = '----------'
        val = ''
      } else if (field === 'processed_at') {
        const x = /-/gi
        this.$refs[ref].innerText = value.replace(x, '/')
        val = value
      } else {
        if (!propToUpdate) {
          this.$refs[ref].innerText = value
          val = value
        }
      }
      if (propToUpdate) {
        propToUpdate[field] = value
      } else {
        this.replacementInfo[field] = val
      }
      window.$('#popover-' + ref).popoverX('hide')
    },

    deleteDetail (i) {
      this.replacementDetails.splice(i, 1)
    },

    async getProducts () {
      this.isLoading = true
      try {
        let params = {}
        let products = await this.$http.post(this.$api_url.replacement_get_products, params)
        let $data = this.$invoiceTools.prepareResult(products.data, 'list', 'SingleReplacement:getProducts')
        if ($data.success === true) {
          this.products = $data.data
          this.$refs.openAddDetailModal.click() // 成功時にモーダル表示
        } else {
          this.$toastr.error($data.data, '処理失敗')
        }
      } catch (error) {
        console.log('SingleReplacement:getProducts:catch(error): ', error)
        this.$toastr.error('エラーのため失敗しました。ご確認後、再試行してください。', 'エラー')
      } finally {
        this.isLoading = false
      }
    },

    getRetrunPropsById (selection, id, name) {
      let ret = ''
      selection.forEach((val, i) => {
        if (val.id === id) {
          ret = val[name]
        }
      })
      return ret
    },
    getRetrunPropsByItemNo (selection, itemNo, name) {
      let ret = ''
      selection.forEach((val, i) => {
        if (val.item_no === itemNo) {
          ret = val[name]
        }
      })
      return ret
    },

    async updateReplacement () {
      try {
        if (this.tempDetails.length < 1) {
          this.$toastr.warning('詳細行を入力してください。')
          return
        }

        this.isLoading = true
        let paramUpdate = {
          replacement_id: this.replacementId,
          information: this.replacementInfo,
          details: this.replacementDetails
        }

        let updateReplacement = await this.$http.post(this.$api_url.replacement_update, paramUpdate)
        let $data = this.$invoiceTools.prepareResult(updateReplacement.data, 'list', 'SingleReplacement:updateReplacement')
        if ($data.success === true) {
          this.$toastr.success('保存に成功しました。', 'Success')
          this.getReplacementDetails()
        } else {
          this.$toastr.error($data.data, 'エラー')
        }
        this.isLoading = false
      } catch (error) {
        this.isLoading = false
        console.log('SingleReplacement:updateReplacement:catch(error): ', error)
        this.$toastr.error('エラーのため失敗しました。ご確認後、再試行してください。', 'エラー')
      }
    },

    async deleteReplacement () {
      this.$dialog.confirm('本当に削除しますか?').then(async () => {
        try {
          this.isLoading = true
          let deleteReplacement = await this.$http.post(this.$api_url.replacement_delete, { replacement_id: this.replacementId })
          let $data = this.$invoiceTools.prepareResult(deleteReplacement.data, '', 'SingleReplacement:deleteReplacement')
          if ($data.success === true) {
            this.$toastr.success('削除が成功しました', 'Success')
            this.$router.replace({ name: 'archive-replacement' })
          } else {
            this.$toastr.error($data.data, 'エラー')
          }
          setTimeout(() => {
            this.isLoading = false
          }, 1000)
        } catch (error) {
          console.log('SingleReplacement:deleteReplacement:catch(error): ', error)
          this.$toastr.error('エラーのため失敗しました。ご確認後、再試行してください。', 'エラー')
        }
      })
    },

    isNotYet () { // まだ未処理が残っている
      let ret = 0
      this.replacementDetails.forEach(val => {
        if (val.replacement_status_id === 1) { // 0否, 1未処理, 2返送待ち, 3処理済み
          ret += 1
        }
      })
      if (ret) {
        return true
      }
      return false
    },
    isAllDone () { // すべて処理済みである
      let ret = 0
      this.replacementDetails.forEach(val => {
        if (val.set_status < 2 && val.replacement_status_id !== 3) { // 0否, 1未処理, 2返送待ち, 3処理済み
          ret += 1
        }
      })
      if (ret) {
        return false
      }
      return true
    },

    withSetItem () {
      let ret = 0
      this.tempDetails.forEach(val => {
        if (val.set_status === 1) {
          ret += 1
        }
      })
      if (ret) {
        this.getBoundProduct()
        return true
      }
      return false
    },

    getSetItem () {
      let ret = []
      this.replacementDetails.forEach(val => {
        if (val.is_set === 1) {
          ret.push(val)
        }
      })
      return ret
    },

    async onChangeStatus (detail, i) {
      const replacementStatusId = this.replacementStatusId[i]['replacement_status_id']

      this.updateField('replacement_status_id', this.tempDetails[i].replacement_status_id, ('status' + i), detail)
      if (!detail.id) return

      this.isLoading = true
      const params = {
        replacement_detail_id: detail.id,
        replacement_status_id: detail.replacement_status_id
      }
      const self = this
      const message = '在庫に反映されたため、戻ることができません'
      this.$http.post(this.$api_url.replacement_change_status, params).then(function (response) {
        if (response.data.status) {
          self.$toastr.success('状態を更新しました', 'Success')
          detail.replacement_status_id = response.data.replacement_status_id
          if ((replacementStatusId === ReplacementStatus.UNTREATED && detail.replacement_status_id === ReplacementStatus.WAITING_FOR_RETURN) ||
            (replacementStatusId === ReplacementStatus.UNTREATED && detail.replacement_status_id === ReplacementStatus.PROCESSED)) {
            if (detail.shipped_at !== null && detail.shipped_stock_type_id !== null && detail.shipped_warehouse_id !== null) {
              self.onChangeShippedWarehouse(detail, i)
            }
          }
          if (detail.replacement_status_id === ReplacementStatus.PROCESSED && detail.arrived_at !== null &&
            detail.arrived_stock_type_id !== null && detail.arrived_warehouse_id !== null) {
            self.onChangeArrivedWarehouse(detail, i)
          }
          // detail.is_moved = response.data.is_moved
        } else {
          if (message === response.data.message) {
            self.$toastr.warning(response.data.message)
            detail.replacement_status_id = response.data.old_id
          } else {
            self.$toastr.error(response.data.message, '処理失敗')
            detail.replacement_status_id = response.data.old_id
          }
        }
      }).finally(function () {
        self.replacementDetails[i] = detail
        self.isLoading = false
      })
    },
    onChangeState (detail, i) {
      this.updateField('replacement_state_id', this.tempDetails[i].replacement_state_id, ('info0000' + i), detail)
      if (!detail.id) return

      this.isLoading = true
      const params = {
        replacement_detail_id: detail.id,
        replacement_state_id: detail.replacement_state_id
      }
      const self = this
      this.$http.post(this.$api_url.replacement_change_state, params).then(function (response) {
        if (response.data.status) {
          self.$toastr.success('動作確認結果を更新しました', 'Success')
          detail.replacement_state_id = response.data.replacement_state_id
        } else {
          self.$toastr.error(response.data.message, '処理失敗')
          detail.replacement_state_id = response.data.old_replacement_state_id
        }
      }).finally(function () {
        self.replacementDetails[i] = detail
        self.isLoading = false
      })
    },
    onChangeReason (detail, i) {
      this.updateField('replacement_reason_id', this.tempDetails[i].replacement_reason_id, ('reason' + i), detail)
      if (!detail.id) return

      this.isLoading = true
      const params = {
        replacement_detail_id: detail.id,
        replacement_reason_id: detail.replacement_reason_id
      }
      const self = this
      this.$http.post(this.$api_url.replacement_change_reason, params).then(function (response) {
        if (response.data.status) {
          self.$toastr.success('返品理由を更新しました', 'Success')
          detail.replacement_reason_id = response.data.replacement_reason_id
        } else {
          self.$toastr.error(response.data.message, '処理失敗')
          detail.replacement_reason_id = response.data.old_replacement_reason_id
        }
      }).finally(function () {
        self.replacementDetails[i] = detail
        self.isLoading = false
      })
    },
    onChangeTestResult (detail, i) {
      this.updateField('test_result', this.tempDetails[i].test_result, ('test_result' + i), detail)
      if (!detail.id) return

      this.isLoading = true
      const params = {
        replacement_detail_id: detail.id,
        test_result: detail.test_result
      }
      const self = this
      this.$http.post(this.$api_url.replacement_change_test_result, params).then(function (response) {
        if (response.data.status) {
          self.$toastr.success('検証結果を更新しました', 'Success')
          detail.test_result = response.data.test_result
        } else {
          self.$toastr.error(response.data.message, '処理失敗')
          detail.test_result = response.data.old_test_result
        }
      }).finally(function () {
        self.replacementDetails[i] = detail
        self.isLoading = false
      })
    },
    onChangeUnitPrice (detail) {
      if (!detail.id) {
        if (!detail.taxclass_id) detail.taxclass_id = 1
        if (Number(detail.taxclass_id) === 1) { // 税区分（1:課税対象, 2:対象外）
          detail.unit_price_inctax = this.$util.getIncludeTax(detail.unit_price, detail.tax_rate)
        } else {
          detail.unit_price_inctax = detail.unit_price
        }
        return
      }

      this.isLoading = true
      const params = {
        replacement_detail_id: detail.id,
        selling_price: detail.unit_price,
        selling_price_inctax: Number(detail.taxclass_id) === 1 ? this.$util.getIncludeTax(detail.unit_price, detail.tax_rate) : detail.unit_price
      }
      const self = this
      this.$http.post(this.$api_url.replacement_change_selling_price, params).then(function (response) {
        if (response.data.status) {
          self.$toastr.success('単価を更新しました', 'Success')
          detail.unit_price = response.data.selling_price
          detail.unit_price_inctax = response.data.selling_price_inctax
        } else {
          self.$toastr.error(response.data.message, '処理失敗')
          detail.unit_price = response.data.old_selling_price
          detail.unit_price_inctax = response.data.old_selling_price_inctax
        }
      }).finally(function () {
        self.isLoading = false
      })
    },
    onChangeRemarks (detail) {
      if (!detail.id) return

      this.isLoading = true
      const params = {
        replacement_detail_id: detail.id,
        remarks: detail.remarks
      }
      const self = this
      this.$http.post(this.$api_url.replacement_change_remarks, params).then(function (response) {
        if (response.data.status) {
          self.$toastr.success('摘要を更新しました', 'Success')
          detail.remarks = response.data.remarks
        } else {
          self.$toastr.error(response.data.message, '処理失敗')
          detail.remarks = response.data.old_remarks
        }
      }).finally(function () {
        self.isLoading = false
      })
    },
    clickIsProcessed () {
      this.isLoading = true
      const params = {
        replacement_id: this.replacementId,
        is_processed: Number(this.replacementInfo.is_processed) === 0 ? 1 : 0
      }
      const self = this
      this.$http.post(this.$api_url.replacement_update_is_processed, params).then(function (response) {
        if (response.data.status) {
          self.$toastr.success('処理状態を更新しました', 'Success')
          self.getReplacementDetails()
        } else {
          self.$toastr.error(response.data.message, '処理失敗')
          self.replacementInfo.is_processed = response.data.old_is_processed
          self.originalInfo.is_processed = response.data.old_is_processed
        }
      }).finally(function () {
        self.isLoading = false
      })
    },

    async onChangeArrivedWarehouse (detail, i) {
      const oldWarehouse = detail.arrived_warehouse ? JSON.parse(JSON.stringify(detail.arrived_warehouse)) : null
      const oldStockType = detail.arrived_stock_type ? JSON.parse(JSON.stringify(detail.arrived_stock_type)) : null
      this.updateField('arrived_warehouse', this.tempDetails[i].arrived_warehouse, ('arrived_warehouse' + i), detail)
      detail.arrived_stock_type = this.tempDetails[i].arrived_stock_type

      if (!detail.id) return

      await this.getSequence()
      detail.arrived_at = this.tempDetails[i].arrived_at
      this.isLoading = true
      const params = {
        replacement_detail_id: detail.id,
        arrived_warehouse_id: detail.arrived_warehouse ? detail.arrived_warehouse.id : null,
        arrived_at: detail.arrived_at,
        arrived_stock_type_id: detail.arrived_stock_type ? detail.arrived_stock_type.id : null,
        reference_number: this.reference_number
      }
      const self = this
      this.$http.post(this.$api_url.replacement_change_arrived_warehouse, params).then(function (response) {
        if (response.data.status) {
          self.$toastr.success('入庫先倉庫を更新しました', 'Success')
          detail.arrived_warehouse = self.warehouses.find(item => item.id === Number(response.data.arrived_warehouse_id))
          detail.arrived_warehouse_id = response.data.arrived_warehouse_id
          detail.arrived_stock_type = self.stockTypes.find(item => item.id === Number(response.data.arrived_stock_type_id))
          detail.arrived_stock_type_id = response.data.arrived_stock_type_id
          detail.arrived_at = response.data.arrived_at ? new Date(response.data.arrived_at).toFormat('YYYY-MM-DD') : null
        } else {
          self.$toastr.error(response.data.message, '処理失敗')
          detail.arrived_warehouse = oldWarehouse
          detail.arrived_stock_type = oldStockType
          detail.arrived_at = response.data.old_arrived_at
        }
      }).finally(function () {
        self.replacementDetails[i] = detail
        self.isLoading = false
      })
    },

    onChangeShippedWarehouse (detail, i) {
      const oldWarehouse = detail.shipped_warehouse ? JSON.parse(JSON.stringify(detail.shipped_warehouse)) : null
      const oldStockType = detail.shipped_stock_type ? JSON.parse(JSON.stringify(detail.shipped_stock_type)) : null
      this.updateField('shipped_warehouse', this.tempDetails[i].shipped_warehouse, ('shipped_warehouse' + i), detail)
      detail.shipped_stock_type = this.tempDetails[i].shipped_stock_type

      if (!detail.id) return
      detail.shipped_at = this.tempDetails[i].shipped_at
      this.isLoading = true
      const params = {
        return_detail_id: this.returnDetail.id,
        replacement_detail_id: detail.id,
        shipped_warehouse_id: detail.shipped_warehouse ? detail.shipped_warehouse.id : null,
        shipped_at: detail.shipped_at,
        shipped_stock_type_id: detail.shipped_stock_type ? detail.shipped_stock_type.id : null
      }
      const self = this
      this.$http.post(this.$api_url.replacement_change_shipped_warehouse, params).then(function (response) {
        if (response.data.status) {
          self.$toastr.success('出庫元倉庫を更新しました', 'Success')
          detail.shipped_warehouse = self.warehouses.find(item => item.id === Number(response.data.shipped_warehouse_id))
          detail.shipped_warehouse_id = response.data.shipped_warehouse_id
          detail.shipped_stock_type = self.stockTypes.find(item => item.id === Number(response.data.shipped_stock_type_id))
          detail.shipped_stock_type_id = response.data.shipped_stock_type_id
          detail.shipped_at = response.data.shipped_at ? new Date(response.data.shipped_at).toFormat('YYYY-MM-DD') : null
        } else {
          if (response.data.message === QuantityProduct.OUT_OF_PRODUCT) {
            self.$toastr.warning(response.data.message)
          } else {
            self.$toastr.error(response.data.message, '処理失敗')
          }
          detail.shipped_warehouse = oldWarehouse
          detail.shipped_stock_type = oldStockType
          detail.shipped_at = response.data.old_shipped_at
        }
      }).finally(function () {
        self.replacementDetails[i] = detail
        self.returnDetail = {}
        self.isLoading = false
      })
    },

    onInputArrivedWarehouseItems (tempDetail) {
      // 全て空の場合か、全て選択されている状態の場合は有効化
      if ((!tempDetail.arrived_at && !tempDetail.arrived_warehouse && !tempDetail.arrived_stock_type) ||
        (tempDetail.arrived_at && tempDetail.arrived_warehouse && tempDetail.arrived_stock_type)) {
        this.disabledWarehouse.arrivedBtn = false
        return
      }
      this.disabledWarehouse.arrivedBtn = true
    },

    onInputShippedWarehouseItems (tempDetail) {
      // 全て空の場合か、全て選択されている状態の場合は有効化
      if ((!tempDetail.shipped_at && !tempDetail.shipped_warehouse && !tempDetail.shipped_stock_type) ||
        (tempDetail.shipped_at && tempDetail.shipped_warehouse && tempDetail.shipped_stock_type)) {
        this.disabledWarehouse.shippedBtn = false
        return
      }
      this.disabledWarehouse.shippedBtn = true
    },

    // showShippedWarehouseProductsModal (detail, i) {
    //   const shippedStockType = this.tempDetails[i].shipped_stock_type
    //   // 新品の場合、今まで通り
    //   if (!shippedStockType || (shippedStockType && shippedStockType.id === 1)) {
    //     this.onChangeShippedWarehouse(detail, i)
    //     return
    //   }
    //
    //   this.selectedDetail = this.tempDetails[i]
    //   this.selectedIdx = i
    //   window.$('#SingleReplacementShippedWarehouseModal').modal()
    // },
    async getSequence () {
      try {
        const response = await this.$http.post(this.$api_url.return_sequence)
        const result = response.data
        if (result.status === true) {
          this.reference_number = result.sequence
        }
      } catch (error) {
        console.log('SingleReplacement:getSequence:catch(error): ', error)
        this.$toastr.error('エラーのため失敗しました。ご確認後、再試行してください。', 'エラー')
      }
    }
  }
}
</script>

<style>
#set-item-list{
    list-style: none;
    padding-left: 0;
    margin-bottom: 0;
}
</style>
